import {
  add2suhfggl4zvkk as add,
  subtract2orl8z9upxd9l as subtract,
  fromInt2ii0rejb1w62w as fromInt,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import { Buffergs925ekssbch as Buffer } from '../../../../../kotlinx-io-kotlinx-io-core/kotlinx/io/Buffer.mjs';
import {
  awaitContent$default2jefvu0cvwa0w as awaitContent$default,
  ByteReadChannel2wzou76jce72d as ByteReadChannel,
} from './ByteReadChannel.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function transferFromDelegate($this) {
  updateConsumed($this);
  var appended = $this.o4k_1.v4f($this.n4k_1.o4i());
  $this.p4k_1 = add($this.p4k_1, appended);
}
function updateConsumed($this) {
  $this.q4k_1 = add($this.q4k_1, subtract($this.p4k_1, $this.o4k_1.q2()));
  $this.p4k_1 = $this.o4k_1.q2();
}
var CountedByteReadChannelClass;
function CountedByteReadChannel() {
  if (CountedByteReadChannelClass === VOID) {
    class $ {
      constructor(delegate) {
        this.n4k_1 = delegate;
        this.o4k_1 = new (Buffer())();
        this.p4k_1 = 0n;
        this.q4k_1 = 0n;
      }
      r4k() {
        updateConsumed(this);
        return this.q4k_1;
      }
      t4i() {
        return this.n4k_1.t4i();
      }
      v4i() {
        return this.o4k_1.n3x() && this.n4k_1.v4i();
      }
      o4i() {
        transferFromDelegate(this);
        return this.o4k_1;
      }
      *w4i(min, $completion) {
        if (this.o4i().q2() >= fromInt(min)) {
          return true;
        }
        if (yield* this.n4k_1.w4i(min, $completion)) {
          transferFromDelegate(this);
          return true;
        }
        return false;
      }
      g4j(cause) {
        this.n4k_1.g4j(cause);
        this.o4k_1.l6();
      }
    }
    protoOf($).c4j = awaitContent$default;
    initMetadataForClass($, 'CountedByteReadChannel', VOID, VOID, [ByteReadChannel()], [1]);
    CountedByteReadChannelClass = $;
  }
  return CountedByteReadChannelClass;
}
function counted(_this__u8e3s4) {
  return new (CountedByteReadChannel())(_this__u8e3s4);
}
//region block: exports
export {
  counted as counted3iniv3aql3f9n,
};
//endregion

//# sourceMappingURL=CountedByteReadChannel.mjs.map
